import { render } from "./DeclaracionMedicamentos.vue?vue&type=template&id=1780a228"
import script from "./DeclaracionMedicamentos.vue?vue&type=script&lang=js"
export * from "./DeclaracionMedicamentos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__